import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import BulkActionsDrawerItemTitle from "components/BulkActions/Drawer/Item/Title";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import { BulkActionsResult } from "components/BulkActions/types";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import { Worker } from "types/generated";

type PrivateWorkerPoolWorkersBulkActionsResultItemProps = {
  item: Worker;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const PrivateWorkerPoolWorkersBulkActionsResultItem = ({
  item,
  resultsMetadata,
  status,
  stopExecution,
}: PrivateWorkerPoolWorkersBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={item.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <BulkActionsDrawerItemTitle text={item.id} />
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(item.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(item.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default PrivateWorkerPoolWorkersBulkActionsResultItem;
